export const pageNodeDef = (id) => {
    return JSON.stringify({
        id: id,
        type: "PageNode",
        parent: 0,
        $type: "PageNode"
    })
}